import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISearchCountModel } from '@apps-common/types/general'

export const getNonProcessedSimCount = async (): Promise<ISearchCountModel> =>
  axios.get('/management/unit/GetAllCancelledNonProcessedSimCount').then((res) => res.data?.data)

type QueryFnType = typeof getNonProcessedSimCount

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useManagementGetNonProcessedSimCount = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0, staleTime: 0, gcTime: 0 },
    queryKey: ['getNonProcessedSimCount'],
    queryFn: () => getNonProcessedSimCount()
  })
